import React, { ReactNode } from "react";
import styled from "@emotion/styled";

//#region Styled Components
const Container = styled.div`
    position: fixed;
    bottom: 0px;
    left: 0px;
    width: 100%;
    background-color: white;
    box-shadow: rgba(0, 0, 0, 0.16) 3px 0px 6px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 70px;
    padding: 0 10px;
    box-sizing: border-box;
    z-index: 999;

    @media screen and (max-width: 767px) {
        height: auto;
        padding: 10px;
    }
`;

const InnerContainer = styled.div<{ columns: number }>`
    display: grid;
    grid-template-columns: repeat(${(props) => props.columns}, auto);
    column-gap: 10px;

    button {
        padding: 10px 10px;
        min-width: 140px;
        border-radius: 5px;
    }

    @media screen and (max-width: 767px) {
        grid-template-columns: 1fr;
        row-gap: 10px;
        width: 100%;

        button {
            min-width: 100%;
            width: 100%;
        }
    }
`;
//#endregion

//#region Types & Interfaces
export interface ReportFooterProps {
    children: ReactNode;
    containerStyles?: React.CSSProperties;
    innerContainerStyles?: React.CSSProperties;
}
//#endregion

//#region Component Definition
export const FixedActionButtons: React.FC<ReportFooterProps> = ({ children, containerStyles, innerContainerStyles }) => {
    const columns = React.Children.count(children);
    return (
        <Container style={containerStyles}>
            <InnerContainer columns={columns} style={innerContainerStyles}>
                {children}
            </InnerContainer>
        </Container>
    );
};
//#endregion
